<template>
    <div id='status-cameras'>
        <div class="row">
            <div class="col-md-12">
                <vuestic-widget headerText="Câmeras">
                    teste
                </vuestic-widget>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style>

</style>
